import { useHistory } from "react-router";
import styled from "styled-components";
import { Card } from "@blueprintjs/core";
import { faBookAlt, faBooks } from "@fortawesome/pro-duotone-svg-icons";
import { faEllipsisH, faMagic } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Container = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 28px;
`;

export const IconCard = styled(Card)`
  width: 180px;
  padding: 32px;
  text-align: center;
`;

const IconCardTitle = styled.div`
  padding-top: 12px;
`;

const TutorialIcon = () => (
  <span className="fa-layers fa-4x">
    <FontAwesomeIcon
      icon={faBookAlt}
      color="var(--global-file-browser-purple)"
    />
    <FontAwesomeIcon icon={faEllipsisH} inverse transform={"shrink-10 up-2"} />
  </span>
);

const TaintModeIcon = () => (
  <span className="fa-layers fa-4x">
    <FontAwesomeIcon
      icon={faBookAlt}
      color="var(--global-file-browser-purple)"
    />
    <FontAwesomeIcon icon={faMagic} inverse transform={"shrink-10 up-2"} />
  </span>
);

export const SplashTutorials = () => {
  const history = useHistory();
  return (
    <Container>
      <IconCard
        interactive
        elevation={1}
        onClick={() => history.push("/learn/basics/1")}
      >
        <TutorialIcon />
        <IconCardTitle>Tutorial</IconCardTitle>
      </IconCard>
      <IconCard
        interactive
        elevation={1}
        onClick={() =>
          (window.location.href =
            "https://semgrep.dev/docs/writing-rules/data-flow/taint-mode")
        }
      >
        <TaintModeIcon />
        <IconCardTitle>Taint mode</IconCardTitle>
      </IconCard>
      <IconCard
        interactive
        elevation={1}
        onClick={() => (window.location.href = "https://semgrep.dev/docs")}
      >
        <FontAwesomeIcon
          icon={faBooks}
          color="var(--global-file-browser-purple)"
          size="4x"
        />
        <IconCardTitle>Docs</IconCardTitle>
      </IconCard>
    </Container>
  );
};
